import React, { useEffect } from "react";
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import '../styles/navbar.css';
import './css/arburetum.css';

const Arburetum = () => {

    const handleDownload = (apkUrl) => {
        const link = document.createElement('a');
        link.href = apkUrl;
        link.download = apkUrl.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(".scroll-animate");
            const windowHeight = window.innerHeight;

            elements.forEach(el => {
                const positionFromTop = el.getBoundingClientRect().top;
                if (positionFromTop - windowHeight <= -100) {
                    el.classList.add("show");
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            {/* Header Section */}
            <div>
                <div className='col m-12'></div>
                <NavigationBar />
            </div>

            {/* Main Content of ARburetum */}
            <div className="contents">
                <div className="logo1 scroll-animate">
                    <img src="/img/ArburetumLOGO.png" alt="Logo" className="icon" style={styles.logo1} />
                </div>

                <h1 className="title-name scroll-animate">AR-ARboretum</h1>
                <h3 className="userManual scroll-animate">User's Manual</h3>
                <h3 className="howToInstall scroll-animate">How to Install the Application</h3>

                <img src="/img/ARS1.png" alt="Logo" className="ARS1 scroll-animate" />
                <p className="ARP1 scroll-animate">
                    Inside, you will find detailed images and parts of different fruit trees — 
                    including their leaves, bark, flowers, and fruits.
                </p>
                <span className="ARA1 scroll-animate">&#8628;</span>

                <img src="/img/ARS2.png" alt="Logo" className="ARS2 scroll-animate" />
                <p className="ARP2 scroll-animate">
                    On each page of the magazine, you will see a QR code.
                    📱 Simply scan any QR code using your smartphone to download the ARBORETUM app.
                </p>

                <img src="/img/ARv2.png" alt="Logo" className="ARQR3 scroll-animate" />
                <p className="ARP3 scroll-animate">
                    If the QR code doesn’t work, there’s an alternative option!
                    Just <span className="download" onClick={() => handleDownload('AR-ARBORETUM-V1.0.2.apk')}>click here</span> to start download
                </p>
                
                <span className="ARA2 scroll-animate">&#8628;</span>
                <img src="/img/ARS3.png" alt="Logo" className="ARS3 scroll-animate" />
                <p className="ARP4 scroll-animate">Once downloaded open the app file and install it.</p>

                <img src="/img/ARS4.png" alt="Logo" className="ARS4 scroll-animate" />
                <p className="ARP5 scroll-animate">
                    Start your Immersive Journey with Fruit Trees Through ARBORETUM
                </p>

                <p className="ARP6 scroll-animate">
                    Minimum specifications needed for the app to function correctly on a device.
                    <br/>
                    <br/>
                    Android Version <br/>
                    11 <br/>
                    <br/>
                    Processor <br/>
                    Octa-core <br/>
                    <br/>
                    RAM <br/>
                    8.00 GB <br/>

                </p>


                
            </div>

            {/* Footer Section */}
            <footer className='footer1'>
                <Footer />
            </footer>
        </>
    );
};

// Styles
const styles = {
    logo1: {
        width: '300px',
        height: '300px',
        objectFit: 'contain',
        borderRadius: '50%',
    },
};

export default Arburetum;
